@if (loading()) {
  <app-spinner></app-spinner>
}

<ngx-app-bar
  class="w-100"
  [title]="'موجودی صندوق‌ها'"
  [rightButton]="{
    icon: 'arrow-right',
    style: 'neutral-link',
    mode: 'icon-only',
    size: 'medium',
  }"
  (onRightButtonClick)="onBackHandler()"
  [leftIcon]="{
    name: canSee() ? 'eye' : 'hide',
  }"
  (onLeftIconClick)="changeSeeStatus()"
/>

<div class="w-100 h-40">
  @if (filteredData()?.length) {
    <div class="profile-asset-list-container">
      <div class="d-flex flex-row justify-content-end h-6 border-bottom">
        @if (canSee()) {
          <span class="balance-profile-asset">
            {{ balance() | number }}
            <span class="rial is-currency"> ریال </span>
          </span>
        } @else {
          <span class="balance-profile-asset line-h-3"> ******** </span>
        }
      </div>

      @for (item of filteredData(); let last = $last; track $index) {
        <div>
          <div
            class="items py-minus"
            [style.padding-bottom]="last ? '0 !important' : ''"
          >
            <div class="d-flex flex-row gap-8">
              <div class="item-logo">
                @if (item.investmentType === 'CrowdFund') {
                  <img
                    src="./wealth-assets/svg/crowd-logo.svg"
                    [alt]="item.title"
                  />
                } @else {
                  <app-image
                    [imageUrl]="item?.logoAddress"
                    defaultImage="wealth-assets/icons/default-instrument.svg"
                  ></app-image>
                }
              </div>
              <div class="d-flex flex-column gap-7">
                <span
                  class="item-title"
                  (click)="goToDetail(item)"
                  >{{ item.title }}</span
                >
                <span class="item-date">{{ item.lastUpdatedAt | jalaliDate }}</span>
              </div>
            </div>

            @if (canSee()) {
              <span class="item-price line-h-3">
                {{ item.price | number }}
                <span class="item-rial is-currency"> ریال </span>
              </span>
            } @else {
              <span class="item-price line-h-3"> ******** </span>
            }
          </div>
          @if (!last) {
            <hr class="items-divider" />
          }
        </div>
      }
    </div>
  }
</div>
